import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const applicationProgressModalComponent = {
  footer: {
    closeButton: 'application-progress-modal.footer.close-button',
    root: 'application-progress-modal.footer.root',
  },
  header: {
    closeButton: 'application-progress-modal.header.close-button',
    h1: 'application-progress-modal.header.h1',
    root: 'application-progress-modal.header.root',
  },
  main: {
    root: 'application-progress-modal.main.root',
    stepper: 'application-progress-modal.main.stepper',
  },
  root: 'application-progress-modal',
} as const satisfies ComponentLocatorMap;
